/**
 * Draws serpentine connectors between grid cards (the grid-light "connectItems"
 * option). Connectors alternate below / above the row, with rounded corners, a
 * start dot and an arrowhead at the end. Drawn in JS so they follow the cards'
 * (equalized, responsive) positions. Only rendered when the cards sit in a
 * single row (desktop); on stacked layouts the SVG is hidden.
 *
 * Markup:
 *   <div data-connect class="relative ...">
 *     <svg class="connectors ..."></svg>
 *     ... <div data-connect-card>…</div> ...
 *   </div>
 */
const NS = "http://www.w3.org/2000/svg";
const R = 21; // corner radius
const REACH = 32; // how far the connector dips below / rises above the cards
const ARROW = 6; // arrowhead arm length

function line(svg, d) {
  const path = document.createElementNS(NS, "path");
  path.setAttribute("d", d);
  path.setAttribute("fill", "none");
  path.setAttribute("stroke", "currentColor");
  path.setAttribute("stroke-width", "1.25");
  path.setAttribute("stroke-linecap", "round");
  path.setAttribute("stroke-linejoin", "round");
  svg.appendChild(path);
}

function dot(svg, x, y) {
  const c = document.createElementNS(NS, "circle");
  c.setAttribute("cx", x);
  c.setAttribute("cy", y);
  c.setAttribute("r", "4");
  c.setAttribute("fill", "currentColor");
  svg.appendChild(c);
}

function drawConnectors() {
  document.querySelectorAll("[data-connect]").forEach((grid) => {
    const svg = grid.querySelector("svg.connectors");
    const cards = [...grid.querySelectorAll("[data-connect-card]")];
    if (!svg || cards.length < 2) return;

    while (svg.firstChild) svg.removeChild(svg.firstChild);

    const gridRect = grid.getBoundingClientRect();
    const rects = cards.map((c) => c.getBoundingClientRect());

    // Only when all cards share a row (desktop). Otherwise hide.
    const oneRow = rects.every((r) => Math.abs(r.top - rects[0].top) < 4);
    if (!oneRow) {
      svg.style.display = "none";
      return;
    }
    svg.style.display = "";
    svg.setAttribute("viewBox", `0 0 ${gridRect.width} ${gridRect.height}`);

    for (let i = 0; i < cards.length - 1; i++) {
      const a = rects[i];
      const b = rects[i + 1];
      const bottom = i % 2 === 0; // 1→2 bottom, 2→3 top, 3→4 bottom, …

      const startX = a.left - gridRect.left + a.width * 0.5;
      const endX = b.left - gridRect.left + b.width * 0.5;

      // Card edge the connector touches, and the horizontal run level.
      const edgeY = (bottom ? a.bottom : a.top) - gridRect.top;
      const runY = bottom ? edgeY + REACH : edgeY - REACH;
      const beforeCorner = bottom ? runY - R : runY + R;

      line(
        svg,
        [
          `M ${startX} ${edgeY}`,
          `L ${startX} ${beforeCorner}`,
          `Q ${startX} ${runY} ${startX + R} ${runY}`,
          `L ${endX - R} ${runY}`,
          `Q ${endX} ${runY} ${endX} ${beforeCorner}`,
          `L ${endX} ${edgeY}`,
        ].join(" ")
      );

      // Start dot on the originating card edge.
      dot(svg, startX, edgeY);

      // Arrowhead at the end, pointing into the next card (arms toward the run).
      const arm = bottom ? ARROW : -ARROW;
      line(
        svg,
        `M ${endX - ARROW} ${edgeY + arm} L ${endX} ${edgeY} L ${endX + ARROW} ${edgeY + arm}`
      );
    }
  });
}

let resizeTimer;
function onResize() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(drawConnectors, 150);
}

// rAF on load so equalized card heights are settled before measuring.
window.addEventListener("load", () => requestAnimationFrame(drawConnectors));
window.addEventListener("resize", onResize);
if (document.fonts && document.fonts.ready) {
  document.fonts.ready.then(drawConnectors);
}
